import SVGS from "../../core/assets/svg";
import ROUTE_CONSTANT from "../../routes/routeconstants";

const {
  Home,
  organization,
  createorganization,
  vieworganization,
  createuser,
  viewuser,
  CreateProjectOrg,
  CreateNotification,
  HolidayCalendar,
  Finance,
  Deprtment,
  Screens,
  Leave,
  Workflw,
  Office,
  Viewoffice,
  payroll2,
  viewpayroll2,
  AuthSignature,
  Invoice,
  Financial,
} = SVGS;

const Data = [
  {
    id: 1,
    label: "Home",
    Icon: Home,
    to: ROUTE_CONSTANT.HOME_ADMIN,
    portalRole: ["1", "2"],
  },
  {
    id: 2,
    label: "Organization",
    Icon: organization,
    portalRole: ["1", "2"],
    subgroup: [
      {
        label: "Create Organization",
        to: ROUTE_CONSTANT.ONBOARD_ORGANIZATION,
        SubIcon: createorganization,
        portalRole: ["1", "2"],
        orgId: 1,
      },
      {
        label: "View organization",
        to: ROUTE_CONSTANT.VIEW_ORGANIZATION,
        SubIcon: vieworganization,
        portalRole: ["1", "2"],
        orgId: 1,
      },
      {
        label: "Department And Roles",
        to: ROUTE_CONSTANT.DEPARTMENT_ROLES,
        SubIcon: Deprtment,
        portalRole: ["1", "2"],
      },

      {
        label: "Screen Configuration",
        to: ROUTE_CONSTANT.SCREEN_CONFIG,
        SubIcon: Screens,
        portalRole: ["1", "2"],
      },
      {
        label: "Type Of Employment",
        to: ROUTE_CONSTANT.TYPEOF_EMPLOYMENT,
        SubIcon: Deprtment,
        portalRole: ["1", "2"],
      },
      {
        label: "Email Config",
        to: ROUTE_CONSTANT.EMAIL_CONFIG,
        SubIcon: Finance,
        portalRole: ["1", "2"],
      },
      {
        label: "Create User",
        to: ROUTE_CONSTANT.CREATE_USER,
        SubIcon: createuser,
        portalRole: ["1", "2"],
      },
      {
        label: "View Users",
        to: ROUTE_CONSTANT.VIEW_USER,
        SubIcon: viewuser,
        portalRole: ["1", "2"],
      },
      {
        label: "Portal Role ",
        to: ROUTE_CONSTANT.PORTAL_ROLE_TAB,
        SubIcon: CreateProjectOrg,
        portalRole: ["1", "2"],
      },
      {
        label: "Screens",
        to: ROUTE_CONSTANT.SCREENS,
        portalRole: ["1", "2"],
        SubIcon: Finance,
      },
    ],
  },
 
];
export default Data;
